"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const contactDetails = [{
  id: "address",
  icon: MapPin,
  label: "Localização",
  value: "Rua Cláudio Soares, 72 - Conj. 1406 -\nPinheiros, São Paulo - SP",
  href: "https://maps.google.com"
}, {
  id: "phone",
  icon: Phone,
  label: "WhatsApp",
  value: "+55 11 96910-0007",
  href: "https://wa.me/5511969100007?text=Olá,%20vim%20pelo%20site%20da%20ITC+%20e%20quero%20entender%20como%20vocês%20podem%20me%20ajudar"
}, {
  id: "email",
  icon: Mail,
  label: "E-mail",
  value: "contato@itcmais.com",
  href: "mailto:contato@itcmais.com"
}, {
  id: "hours",
  icon: Clock,
  label: "Funcionamento",
  value: "Seg - Sex: 09h às 19h",
  href: null
}];
export default function WhereToFindUs() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: mapRef,
    isVisible: isMapVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222218" id="onde-estamos" className="bg-background text-foreground py-[var(--section-vertical-padding)] overflow-hidden section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground tracking-tighter">
                Onde Estamos
              </h2>
              <p className="text-muted-foreground text-lg max-w-md font-default leading-relaxed">
                Nosso estúdio de podcast em Pinheiros oferece infraestrutura de ponta para gravação profissional e produção audiovisual de alto impacto.
              </p>
            </div>

            <div className="flex flex-col gap-6 mt-4">
              {contactDetails.map((item, i) => <div key={item.id} data-index={i} className="flex items-start gap-5 group">
                  <div className="flex-shrink-0 mt-1 flex items-center justify-center size-12 rounded-lg bg-primary/10 text-primary transition-all duration-300 group-hover:bg-primary group-hover:text-primary-foreground shadow-sm">
                    <item.icon className="size-5" strokeWidth={2} />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs font-mono font-semibold text-primary/70 uppercase tracking-widest mb-1">
                      {item.label}
                    </span>
                    {item.href ? <Link to={item.href} className="text-lg font-default font-medium text-foreground hover:text-primary transition-colors duration-200">
                        {item.value}
                      </Link> : <span className="text-lg font-default font-medium text-foreground">
                        {item.value}
                      </span>}
                  </div>
                </div>)}
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="rounded-lg px-8 bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg hover:shadow-primary/20 transition-all">
                <Link to="https://wa.me/5511969100007">
                  Falar com especialista
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={mapRef} className={`relative w-full aspect-square md:aspect-[4/3] lg:aspect-square rounded-3xl overflow-hidden shadow-2xl border border-border transition-all duration-1000 delay-200 ease-out ${isMapVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="absolute inset-0 bg-primary/5 mix-blend-saturation z-10 pointer-events-none"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/pinheiros_studio_map_location.png" alt="Mapa de localização em Pinheiros São Paulo" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105 grayscale contrast-125 opacity-90" />
            
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 flex flex-col items-center animate-bounce">
              <div className="bg-primary text-primary-foreground p-4 rounded-lg shadow-3xl ring-4 ring-primary/20">
                <MapPin className="size-7" />
              </div>
              <div className="w-3 h-3 bg-primary rounded-lg mt-1 opacity-60 blur-[1px]"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}